/**
 * マーク掲載順
 *
 * @export MarkPublishOrder
 * @class MarkPublishOrder
 */
export class MarkPublishOrder {
    constructor(
        public markGroupCode: string,
        public markCode: string,
        public markName: string,
        public publishOrder: string,
        public markFileUrl: string,
    ) {}
}
